import React from "react";
import "./Category.css";
import bedroom from "../assets/images/bedroom.png";
import livingroom from "../assets/images/livingroom.png";
import RugThree from "../assets/images/RugThree.png";
import { Link } from "react-router-dom"; //Link

function Rug() {
  return (
    <>
      <div className="category_outer_main">
        <div className="container-fluid">

          <div className="category_inner rugby-room-inner">
            <div className="row g-3">
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <Link to="/products" className="category_item_outer">  
                  <div
                    className="category_item"
                    style={{ backgroundImage: `url(${bedroom})` }}
                  >
                    <div className="category_text">
                     <Link to="/products"> Shop by Bedroom </Link>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <Link to="/products" className="category_item_outer">  
                  <div
                    className="category_item"
                    style={{ backgroundImage: `url(${livingroom})` }}
                  >
                    <div className="category_text">
                        <Link to="/products">Shop by Living room  </Link>
                    </div>
                  </div>
               </Link>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                 <Link to="/products" className="category_item_outer">  
                  <div
                    className="category_item"
                    style={{ backgroundImage: `url(${RugThree})` }}
                  >
                    <div className="category_text">
                       <Link to="/products">Shop by Dining room  </Link>
                    </div>
                  </div>
               </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Rug;
